import type { IntegrationPlatform } from '@bandos/shared'

/**
 * Get human-readable display name for an integration platform
 * This is a flexible utility that handles any integration platform
 *
 * @param platform - The integration platform identifier
 * @returns Human-readable display name
 */
export function getIntegrationDisplayName(platform: IntegrationPlatform | string): string {
  // Convert platform identifier to display name
  // Handles kebab-case and camelCase formats
  const displayNameMap: Record<string, string> = {
    trello: 'Trello',
    jira: 'Jira',
    'azure-devops': 'Azure DevOps',
    azuredevops: 'Azure DevOps',
  }

  // Return mapped name if available, otherwise format the platform name
  if (displayNameMap[platform.toLowerCase()]) {
    return displayNameMap[platform.toLowerCase()]
  }

  // Fallback: Capitalize and format the platform name
  return platform
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
